import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=28cca163&scoped=true&"
import script from "./ModalAlert.vue?vue&type=script&lang=js&"
export * from "./ModalAlert.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=28cca163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cca163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cca163')) {
      api.createRecord('28cca163', component.options)
    } else {
      api.reload('28cca163', component.options)
    }
    module.hot.accept("./ModalAlert.vue?vue&type=template&id=28cca163&scoped=true&", function () {
      api.rerender('28cca163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalAlert.vue"
export default component.exports